module.exports = __webpack_public_path__ + "img/content_left.6a53235.png";